import {round, floor} from 'lodash'

export default function formatSeconds(totalSeconds) {
  if (!totalSeconds || totalSeconds < 0){
    return '0:00'
  }

  const roundedSeconds = round(totalSeconds)
  const minutes = floor(roundedSeconds/60)
  const seconds = roundedSeconds - (minutes*60)
  const precedingZero = seconds >= 10 ? '' : 0

  return `${minutes}:${precedingZero}${seconds}`
}
